import React, { Component } from 'react';
import {getYoutubeTitle} from './getYoutubeTitle.js';

class DiscogsThumbnail extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    getYoutubeThumbnail() {
        return 'https://img.youtube.com/vi/' + this.props.videoId + '/1.jpg';
    }

    render() {
        let label = this.props.selectedLabel;
        if (label === undefined) {
            return (
                <div></div>
            );
        }
        return (
            <div className="youtube-discogs-container">
              <img className="youtube-thumbnail" src={label.thumbnail}/>
              <div className="discogs-youtube-name">
                {label.name}
              </div>
            </div>
        );
    }
}

export default DiscogsThumbnail;
